import { z } from 'zod';

import { WorkoutPlanId } from '../BrandedIds';
import { BaseUpsertTransactionSideEffect } from './BaseUpsertTransactionSideEffect';

export const UpsertPaymentDefermentSideEffectContext = BaseUpsertTransactionSideEffect.extend({
  workoutPlanId: WorkoutPlanId,
});
export const UpsertPaymentDefermentSideEffect = UpsertPaymentDefermentSideEffectContext.extend({
  type: z.literal('upsertPaymentDeferment'),
});
export type UpsertPaymentDefermentSideEffect = z.infer<typeof UpsertPaymentDefermentSideEffect>;
